const Create = () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/ServiceGoals/Create')
const Edit = () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/ServiceGoals/Edit')
const Search = () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/ServiceGoals/Search')

export default [
  {
    path: 'service-goals/create',
    name: 'ServiceGoalsCreate',
    component: Create,
    meta: {
      title: 'Adicionar Meta de Serviço',
      ensureCanSeeFunctionalities: true,
      permission: {
        name: 'serviceGoals',
        action: 'create'
      }
    }
  },
  {
    path: 'service-goals/:id/edit',
    name: 'ServiceGoalsEdit',
    component: Edit,
    meta: {
      title: 'Editar Meta de Serviço',
      ensureCanSeeFunctionalities: true,
      permission: {
        name: 'serviceGoals',
        action: 'read'
      }
    }
  },
  {
    path: 'service-goals',
    name: 'ServiceGoalsSearch',
    component: Search,
    meta: {
      title: 'Metas de Serviço',
      ensureCanSeeFunctionalities: true,
      permission: {
        name: 'serviceGoals',
        action: 'read'
      }
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/dashboard/service-goals.js